// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.custom-font[data-v-2f54d895] {\r\n    font-family: Golos, GolosText, sans-serif;\n}\n.custom-textbox[data-v-2f54d895] {\r\n    border-radius: 5px;\r\n    color: black;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
